import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function SkeletonGrid() {
  return (
    <div className="flex gap-8 flex-wrap">
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
      <div>
        <Skeleton className="w-[200px] h-[300px] rounded-lg" />
        <Skeleton className="w-[200px] mt-1 h-7" />
      </div>
    </div>
  );
}

export default SkeletonGrid;
